angular.module('zc.zenclerkS')
  .controller('ZcsReportShowController', ZcsReportShowController);

ZcsReportShowController.$inject = ['$stateParams', 'invoices', 'project'];
function ZcsReportShowController($stateParams, invoices, project) {
  const vm = this;
  vm.month = $stateParams.month;
  vm.project = project;
  vm.invoices = invoices;
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/reports/show/report_show.controller.js